import React, { Fragment } from 'react';
import {Stack, Typography, useTheme } from '@mui/material';

import Icon from 'presentation/icons';
import { translations } from 'presentation/translations-new';
import { AlertActions, AlertModal, MainFooter } from 'presentation/components';
import { useSelectType } from './hooks/useSelectType';
import { OptionsGrid, StyledOptionCard } from './styles';
const infoModal = translations['pt-br'].privateFlow.refund.previewServiceType.infoModal;

export function SelectTypeV2() {
	const theme = useTheme();
	const { handleOptionClick, options, infoModalVisible, setInfoModalVisible } =
		useSelectType();

	function handleCloseInfoModal() {
		setInfoModalVisible(false);
	}

	return (
		<Fragment>
			<AlertModal
				open={infoModalVisible}
				onClose={handleCloseInfoModal}
				headerTitle={infoModal.headerTitle}
				title={infoModal.title}
				description={infoModal.description}
				variant="info"
				footerContent={
					<AlertActions
						flexDirection="column-reverse"
						primaryText={infoModal.primaryBtn}
						primaryAction={handleCloseInfoModal}
						secondaryText={infoModal.secondaryBtn}
						secondaryAction={handleCloseInfoModal}
					/>
				}
			/>

			<Stack
				px={2}
				py={4}
				sx={{
					width: { xs: '100%', sm: 'fit-content' },
					margin: { xs: 0, sm: '0 auto' },
				}}>
				<Typography variant="subtitle2" color="textSecondary" sx={{ mb: 2 }}>
					Selecione uma opção
				</Typography>
				<OptionsGrid>
					{options.map(option => (
						<StyledOptionCard key={option} onClick={() => handleOptionClick(option)}>
							<Typography variant="body1" color="text.primary">
								{option}
							</Typography>
							<Icon
								name="arrow-right"
								size={24}
								color={theme.palette.primary.main}
							/>
						</StyledOptionCard>
					))}
				</OptionsGrid>
			</Stack>
			<MainFooter />
		</Fragment>
	);
}
